import Common from "./Common";
import web from "../src/images/about.svg";

function About() {
  return (
    <>
      <Common
        tagLine="Front-End Web Developer"
        imgSrc={web}
        visit="/Contact"
        btnName="Contact now"
        discription="Hi! My name is I am a Front-end React JS developer adequate knowledge of UI/UX design. A life long learner who has a passion for tech industry, and loves crafting experiences for usability & interaction"
      />
    </>
  );
}

export default About;
